(() => {
  const getOptionName = (option) => {
    const namedInput = option.querySelector('[data-option-name]');
    if (namedInput?.dataset.optionName) return namedInput.dataset.optionName.trim().toLowerCase();

    const select = option.querySelector('select[name^="options["]');
    const match = select?.name.match(/^options\[(.+)]$/);
    return match ? match[1].trim().toLowerCase() : '';
  };

  const placeColorBeforeSize = (picker) => {
    const options = [...picker.querySelectorAll(':scope > .product-form__input')];
    const color = options.find((option) => getOptionName(option) === 'color');
    const size = options.find((option) => getOptionName(option) === 'size');

    if (!color || !size || color.nextElementSibling === size) return;
    picker.insertBefore(color, size);
  };

  const updatePickers = (root = document) => {
    root.querySelectorAll('variant-selects').forEach(placeColorBeforeSize);
  };

  updatePickers();

  new MutationObserver(() => updatePickers()).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
